/**
 * OAuth1 / Telegram / Discord compatibility path: backend still redirects a
 * short-lived PingPing JWT in a URL query parameter. Scrub it immediately
 * after parsing, before any authenticated API request or redirect.
 * Long-term replacement: one-time POST ticket + httpOnly session.
 */
export function consumeLegacyOAuthCallback(searchParams,history,pathname) {
 const token=searchParams.get('token');
 const errorMessage=searchParams.get('message');
 const fromDiscordBot=searchParams.get('source')==='discord_bot';
 if(token||errorMessage)history.replaceState(history.state,'',pathname);
 return {token,errorMessage,fromDiscordBot};
}
